<template>
  <div class="map-link">
    <a target="_blank" :href="'https://goo.gl/maps/' + mapId">
      如何前往<span>{{name}}</span> <font-awesome-icon icon="caret-right" fixed-width/>
    </a>
  </div>
</template>

<script>
export default {
  name: 'map-link',
  props: {
    name: String,
    mapId: String
  }
}
</script>

<style scoped>
.map-link {
  text-align: right;
}

.map-link>a {
  color: #fff;
  opacity: .6;
  font-size: .8em;
  text-decoration: underline;
}

.map-link>a:hover {
  opacity: 1;
}
</style>
